<template>
  <div class="content">
    <div class="bodycontent" v-loading="loading">
      <el-form
        :model="formData"
        ref="formData"
        label-width="180px"
        :rules="rules"
      >
        <el-form-item label="油卡名称" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="等级" prop="level">
          <el-input-number
            v-model="formData.level"
            class="input_box_small"
            :controls="false"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="关联类别" prop="type_id">
          <el-select
            v-model="formData.type_id"
            placeholder="请选择分类"
            style="width:150px"
            @change="changeClass"
            :disabled="!if_add"
          >
            <el-option
              v-for="item in oil_typeArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="油品选择" prop="goods_id">
          <multipleChoice
            :alone="1"
            :Datas="oil_listArr"
            @checkedGoods="checkedGoods"
            ref="choiceChild"
          ></multipleChoice>
        </el-form-item>
        <el-form-item label="适用油站" prop="roomS">
          <el-select
            v-model="formData.roomS"
            multiple
            placeholder="请选择门店"
            @change="$forceUpdate()"
          >
            <el-option
              v-for="item in store_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="item.disable"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 新增 -->
        <el-form-item label="是否为永久">
          <el-radio-group v-model="formData.is_forever">
            <el-radio :label="1">永久</el-radio>
            <el-radio :label="0">非永久</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效时间(天)" v-if="formData.is_forever == 0">
          <el-input-number
            v-model="formData.valid_date"
            class="input_box_small"
            :controls="false"
          ></el-input-number>
          <div class="color">
            说明：非永久的情况下，将停止用户充值，如用户账户中还有余额则不影响使用
          </div>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio-group v-model="formData.is_show">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否默认">
          <el-radio-group v-model="formData.is_default">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用规则">
          <el-input
            v-model="formData.des"
            class="input_box"
            type="textarea"
            rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button
          type="primary"
          @click="save('formData')"
          :loading="uploadLoading"
          >提交</el-button
        >
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="3"
      ></selectCommodity>
    </el-dialog> -->
  </div>
</template>
<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import multipleChoice from "@/components/commodity/multipleChoice.vue";
import { mapGetters } from "vuex";
import {
  addRefule,
  detailRefule,
  editRefule,
  getSelectArr,
  goodsList
} from "@/api/vip";
import { storeSelect } from "@/api/employee";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    selectCommodity,
    multipleChoice
  },
  mounted() {
    this.init();
    this.initStoreType();
    this.getOilTypeSelect();
  },
  data() {
    return {
      formData: {
        roomS: [],
        type_id: "", //关联油品类别
        room_id: "",
        level: "",
        is_forever: "", //0 非
        // valid_day: "", //是否显示0：不显示1：显示
        is_show: "", //是否显示0：不显示1：显示
        is_default: "", //是否显示0：不显示1：显示
        goods_id: "", //油品
        des: "" //使用规则
      },
      rules: {
        name: [{ required: true, message: "请输入油卡名称", trigger: "blur" }],
        level: [{ required: true, message: "请输入等级", trigger: "blur" }],
        goods_id: [{ required: true, message: "请选择油品", trigger: "blur" }],
        type_id: [
          {
            required: true,
            message: "请选择油品类别",
            trigger: "blur"
          }
        ],
        roomS: [
          {
            type: "array",
            required: true,
            message: "请选择油品类别",
            trigger: "blur"
          }
        ]
      },
      if_add: true, //是否是新添加
      loading: false, //页面loading
      uploadLoading: false, //上传时loading
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      classType: [], //类别
      checkedRefule: [], //选中的油品
      oil_typeArr: [], //油品列表
      oil_listArr: [], //对应油品分类列表
      checkAll: [],
      store_options: [], //门店列表
      isIndeterminate: true
    };
  },
  methods: {
    checkedGoods(index) {
      console.log("11we ", index);
      this.formData.goods_id = index.join(",");
    },
    // 关联类别对应的油品
    changeClass(index) {
      this.$refs.choiceChild.checks = [];

      // this.formData.goods_id = "";
      console.log("index关联类别", index, this.checkedRefule);
      this.oilTypeData(index);
    },
    init() {
      this.formData = {
        is_forever: 1,
        is_pay: 1,
        is_show: 1,
        is_default: 0
      };
      //判断是否是编辑会员卡
      if (this.$route.query.vid) {
        this.loading = true;
        this.if_add = false;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.vid
        };
        detailRefule(data).then(res => {
          console.log("表单详情", res);
          if (res.code == 200) {
            this.formData = Object.assign({}, res.data);
            var arrs = res.data.goods_id.split(",");
            arrs.forEach(item => {
              this.checkedRefule.push(item * 1);
            });
            // 改变组件状态
            this.$refs.choiceChild.checks = this.checkedRefule;

            var room = res.data.room_id.split(",");
            this.formData.roomS = [];
            room.forEach(item => {
              this.formData.roomS.push(item * 1);
            });
            delete this.formData.create_time;

            this.oilTypeData(res.data.type_id);
          }
          this.loading = false;
        });
      }
    },
    // 门店列表
    initStoreType() {
      storeSelect({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.store_options = res.data;
            this.store_options.forEach(item => {
              item.disable = false;
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getOilTypeSelect() {
      getSelectArr(this.token, this.app_id).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.oil_typeArr = res.data;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //保存表单
    save(formname) {
      console.log("表单上传数据", this.formData);
      this.$refs[formname].validate(valid => {
        if (valid) {
          this.formData.room_id = this.formData.roomS.join(",");
          delete this.formData.roomS;
          var data = { ...this.formData };
          data.token = this.token;
          data.app_id = this.app_id;
          // 新增内容
          var ids = [];
          this.sList.forEach(item => {
            ids.push(item.id);
          });

          console.log("表单上传数据", data);
          if (this.if_add) {
            addRefule(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          } else {
            editRefule(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    // 根据分类获取油品
    oilTypeData(index) {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        name: this.search_con,
        store_id: 0,
        type_id: index
      };

      goodsList(data).then(res => {
        if (res.code == 200) {
          this.$refs.choiceChild.goods = res.data;
          console.log("goodslist", this.formData);
          if (this.formData.goods) {
            this.$refs.choiceChild.mallCheckAll =
              this.formData.goods.length < res.data.length ? false : true;
          }
        } else {
          this.$refs.choiceChild.goods = [];
        }
      });
    }
    //
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.color {
  color: #ccc;
}
.minWidth {
  min-width: 80px;
}
.buttonInput {
  width: 100px;
  padding: 0 10px;
  color: #409eff;
  height: 28px;
  line-height: 28px;
  border: 1px solid #409eff;
  border-radius: 5px;
  text-align: center;
}
.padding10 {
  padding: 0 10px;
  display: flex;
}
.margin10 {
  margin: 10px 0;
  display: flex;
}
.smallinput {
  width: 100px;
  padding: 0 10px;
}
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: #fff;
    .input_box {
      width: 400px;
    }
    .input_box_small {
      width: 120px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
}
</style>
